import { IPerformanceEvaluationMethod } from "models/PerformanceEvaluationMethodModel";
import { BaseService } from "./base.service";

class PerformanceEvaluationMethodInternal extends BaseService {
	getPerformanceEvaluationMethodList = async (): Promise<
		IPerformanceEvaluationMethod[]
	> =>
		this.callApi<IPerformanceEvaluationMethod[]>(
			`PerformanceEvaluationMethod/GetAll`,
			"GET"
		);
}

export const PerformanceEvaluationMethodService =
	new PerformanceEvaluationMethodInternal();
